import React, { useEffect, useState } from "react";
import Country from "./Country/Country";
import State from "./State/State";
import Region from "./Region/Region";
import Division from "./Division/Division";
import Pincode from "./Pincode/Pincode";
import District from "./District/District";
import Block from "./Block/Block";
import Area from "./Area/Area";
import Option from "./Option/Option";
import SubCategory from "./SubCategory/SubCategory";
import LocationMap from "./LocationMap/LocationMap";
import Map from "./Map/Map";
import Tier from "./Tier/Tier";
import City from "./City/City";
import TierMapper from "./TierMapper/TierMapper"
import { AuthContext } from "@/auth/AuthContext";
import { useContext } from "react";

const Location = () => {
  const {user} = useContext(AuthContext);
  const [editable, setEditable] = useState(false);
  const [activeComponent, setActiveComponent] = useState(localStorage.getItem('locationActive') || "Country");

  useEffect(()=>{
    if(user?.roleId==1 || user?.roleId==2){
      setEditable(true)
    }
  },[user])
  // Array with tab names and corresponding components
  const tabs = [
    { name: "Country", component: <Country editable={editable}/> },
    { name: "State", component: <State editable={editable} /> },
    { name: "Region", component: <Region editable={editable}/> },
    { name:"Division", component:<Division editable={editable} />},
    { name: "Pincode", component: <Pincode editable={editable} /> },
    { name: "District", component: <District editable={editable}/> },
    { name: "Block", component: <Block editable={editable} /> },
    { name: "Area", component: <Area editable={editable}/> },
    // { name: "Option", component: <Option editable={editable} /> },
    { name: "Map", component: <Map editable={editable} /> },
    { name: "Location Map", component: <LocationMap editable={editable} /> },
    { name: "Tier", component: <Tier editable={editable} /> },
    { name: "City", component: <City editable={editable} /> },
    { name: "Tier Mapper", component: <TierMapper editable={editable} /> },
    // { name: "Sub-Category", component: <SubCategory /> },
  ];

  // Find the active tab and its component
  const renderComponent = () => {
    const activeTab = tabs.find(tab => tab.name === activeComponent);
    return activeTab ? activeTab.component : null;
  };

  const changeActiveComponent = (name)=>{
    setActiveComponent(name)
    localStorage.setItem('locationActive',name);
  }

  return (
    <div className="min-h-screen flex flex-col items-center p-6 pt-14">
      <div className="flex flex-col justify-center items-center w-full sticky top-14 bg-[var(--bgColor)]">
      <h1 className="text-xl m-4 font-semibold">Location {editable}</h1>
      <div className="flex gap-2 max-w-100 flex-wrap mb-2">
        {tabs.map(({ name }) => (
          <button
            key={name}
            className={`p-2 rounded-lg text-sm border-b-2 min-w-[100px] ${
              activeComponent === name
                ? "activeBtn text-white"
                : "bg-neutral-50 text-gray-800 hover:bg-blue-100"
            }`}
            onClick={() => {changeActiveComponent(name)}}
          >
            {name}
          </button>
        ))}
      </div>
      </div>

      {renderComponent()}
    </div>
  );
};

export default Location;
